window.jQuery = window.$ = require('jquery')

require('bootstrap')
require('mdbootstrap')
require('../../../fontawesome-pro-5.2.0-web/js/all') // use either scss or js version, not both
require('../../../fontawesome-pro-5.2.0-web/js/v4-shims') //  use either scss or js version, not both
require('ekko-lightbox')
require('slick-carousel')
require('smartmenus')
require('../../../../../node_modules/smartmenus/dist/addons/bootstrap-4/jquery.smartmenus.bootstrap-4.js')
require('../../../../../node_modules/@bower_components/magnific-popup/dist/jquery.magnific-popup')

window.Swiper = require('swiper/dist/js/swiper')

$(document).ready(function () {

  if ($(document).scrollTop() > $('nav').outerHeight()) {
    $('nav').addClass('shrink')
  } else {
    $('nav').removeClass('shrink')
  }

  $(window).scroll(function () {
    if ($(document).scrollTop() > $('nav').outerHeight()) {
      $('nav').addClass('shrink')
      $('header').addClass('shrink')
    } else {
      $('nav').removeClass('shrink')
      $('header').removeClass('shrink')
    }
  })

  // $('.dropdown-menu .dropdown-toggle').on('click', function () {
  //   var $el = $(this)
  //   var $parent = $el.offsetParent('.dropdown-menu')
  //
  //   if (!$el.next().hasClass('show')) {
  //     $el.parents('.dropdown-menu').first().find('.show').removeClass('show')
  //   }
  //   $el.next('.dropdown-menu').toggleClass('show').parent('li').toggleClass('show')
  //
  //   $el.parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function () {
  //     $('.dropdown-menu .show').removeClass('show')
  //   })
  //
  //   if (!$parent.parent().hasClass('navbar-nav')) {
  //     $el.next().css({'top': $el[0].offsetTop, 'left': $parent.outerWidth()})
  //   }
  //
  //   return false
  // })

  $('#slick-banner .slick-banner-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    arrows: false,
    dots: true,
    appendDots: $('.slick-banner-dots')
  })

  var swiper = new Swiper('#our-services.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 2000,
    },
  })

  $('#modalForm').on('show.bs.modal', function () {
    var email = $('input[name="newsletter_email"]').val()
    var modal = $(this)
    $('#frmNewsletterSubscribe').find('#newsletter_email').val(email)
  })

  $('#frmNewsletterSubscribe').on('submit', function (event) {
    event.preventDefault()
    var name = $('#frmNewsletterSubscribe').find('#newsletter_name').val()
    var email = $('#frmNewsletterSubscribe').find('#newsletter_email').val()
    var newsletter_agree = $('#frmNewsletterSubscribe').find('#newsletter_agree').val()
    var locale = $('#frmNewsletterSubscribe').find('#newsletter_locale').val()
    $.post($('#frmNewsletterSubscribe').data('post'), {
      name: name,
      email: email,
      locale: locale,
      newsletter_agree: newsletter_agree
    }, function (data) {
      if (data.status == 1) {
        $('#frmNewsletterSubscribe').find('#newsletter_name').val('')
        $('#frmNewsletterSubscribe').find('#newsletter_email').val('')
        $('#modalForm').modal('hide')
      }
      if (data.status == 0) {

      }
      $('#modalResult').find('.modal-body p').html(data.message)
      $('#modalResult').modal('show')
    })
  })

  imgToBG($('.bg-img'), '.img-bg')

  var swiper2 = new Swiper('#inner-banner.swiper-container', {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: false
  })

    $('.leadership .img_leadership').on('click', function() {
        if($(window).width() > 768 ) {
            $('.leadership > .row > div.active').removeClass('active');
            $('.leadership > .row > div .close').remove();
            $(this).parent('div').addClass('active');
            $('.custom-pop').fadeIn();
            $(this).siblings('.desc_leadership').append('<span class="close"><i class="fa fa-times"></i></span>');
            $(this).siblings('.desc_leadership').find('.close').on('click', function() {
                $('.custom-pop').fadeOut();
                $(this).remove();
                $('.leadership > .row > div.active').removeClass('active');
            });
        }else{
            $(this).parent('div').addClass('active');
            if($(window).width() < 768 ) {
                $('.desc_leadership').fadeIn().css({'height': $(this).parent().innerHeight()});
            }
            $(this).siblings('.desc_leadership').append('<span class="close"><i class="fa fa-times"></i></span>');
            $(this).siblings('.desc_leadership').find('.close').on('click', function() {
                $(this).remove();
                $('.leadership > .row > div.active').removeClass('active');
            });
        }
    });

    $('.close, .custom-pop').on('click', function(){
      $('.custom-pop').fadeOut();
      $('.leadership > .row > div.active').removeClass('active');
    });

})

function imgToBG (ele, _imgClass) {
  if (ele.length > 0) {
    ele.each(function () {
      var _this = $(this), img = _this.find(_imgClass).eq(0) || _this.find('img').eq(0)
      _this.css({'background': 'url("' + img.attr('src') + '")'})
      img.hide()
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/front/unocms-v4/main.js